import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='foot'>
        <div className="copy">
        <b>Copyright &copy; 2023 Dental Care</b>
        </div>
     

      
    </div>
  )
}

export default Footer
